import { SET_REGIONS, REGIONS_ERROR } from '../types/RegionsTypes';

const initialState = {
  regions: [],
  loading: true,
  error: false,
};

const regionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REGIONS:
      return {
        ...state,
        regions: action.regions,
        loading: false,
      };
    case REGIONS_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };
    default:
      return state;
  }
};

export default regionsReducer;
